import React, { useState } from 'react'
import { post } from '../../utils/api-routes.common'

const RequestTrackingTest: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [result, setResult] = useState<string>('')

  const testTrackedRequest = async () => {
    setIsLoading(true)
    setResult('Making tracked request...')

    try {
      // This will be a tracked request that should prevent page reload
      const response = await post('/test-endpoint', {
        test: 'data',
      }).toPromise()
      setResult('Request completed successfully')
    } catch (error) {
      setResult('Request failed (expected for test endpoint)')
    } finally {
      setIsLoading(false)
    }
  }

  const testUntrackedRequest = async () => {
    setIsLoading(true)
    setResult('Making untracked request...')

    try {
      // This will be an untracked request that should NOT prevent page reload
      const response = await fetch('/api/test-endpoint', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ test: 'data' }),
      })
      setResult('Untracked request completed')
    } catch (error) {
      setResult('Untracked request failed (expected for test endpoint)')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div style={{ padding: '20px', border: '1px solid #ccc', margin: '20px' }}>
      <h3>Request Tracking Test</h3>
      <p>Test the request tracking functionality:</p>
      <ul>
        <li>
          Click &quot;Test Tracked Request&quot; and try to reload the page - it
          should show a warning
        </li>
        <li>
          Click &quot;Test Untracked Request&quot; and try to reload the page -
          it should allow reload
        </li>
      </ul>

      <button
        onClick={testTrackedRequest}
        disabled={isLoading}
        style={{ marginRight: '10px' }}
      >
        Test Tracked Request
      </button>

      <button onClick={testUntrackedRequest} disabled={isLoading}>
        Test Untracked Request
      </button>

      {isLoading && <p>Loading...</p>}
      {result && <p>Result: {result}</p>}
    </div>
  )
}

export default RequestTrackingTest
